<template>
  <div class="maps-marker--container" :class="{ selected: selected, 'request-only': product.min_price == 0 }">
    <div class="maps-marker" :class="{ selected: selected }" @click="$emit('click')" >

    </div>
    <div class="maps-marker--content product-item thumb " v-if="selected">
      <div class="maps-marker--close-icon">
          <i class="el-icon-error" @click="setClose"/>
      </div>
      <div class="row">
        <div class="col-lg-12 col-xs-4">
          <ul class="mini-slider">
            <li class="mini-slider--slide" :style="`background-image:url('${product.product_map_image_path_cache}')`" />
          </ul>

        </div>
        <div class="col-lg-12 col-xs-8">
          <div class="spacer">
            <h2>{{ product.name }}</h2>
            <b class="h4 highlight">{{ product.location}}</b>
          </div>
        </div>
      </div>

      <div class="maps-marker--text">

        <div class="text">{{ product.produktbeschreibung_kurz}} </div>
      </div>
      <div class="row maps-marker--footer">
      <div class="maps-marker--price col-xs-5 col-md-6 col-sm-6 col-lg-6">
        <template v-if="product.min_price > 0">
          ab {{product.min_price}} EUR <span class="small">p.P./Nacht</span>
        </template>
        <template v-else>
          nur auf Anfrage
        </template>
      </div>
      <div class="text-right maps-marker--buttons col-xs-7 col-md-6 col-sm-6 col-lg-6">
        <a class="btn btn-primary" :href="product.url">Details</a>
        <a class="btn btn-success" :href="product.booking_url" v-if="hasCustomer">Buchen</a>
      </div>
      </div>


    </div>
  </div>
</template>
<script>
import ratingDisplay from './ratingDisplay.vue';
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'rating-display': ratingDisplay
  },
  computed: {
    hasCustomer(){
      return window.mapsHasCurrentCustomer == true
    }
  },
  methods: {
    setClose(){
      this.selected = false
      this.$emit('close')
    }
  }
}
</script>
